module.exports = __webpack_public_path__ + "img/game_pic1.d411518a.jpg";